import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=e687e8b2&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\LAVK\\Desktop\\MedSafe\\System\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e687e8b2')) {
      api.createRecord('e687e8b2', component.options)
    } else {
      api.reload('e687e8b2', component.options)
    }
    module.hot.accept("./LoginPage.vue?vue&type=template&id=e687e8b2&", function () {
      api.rerender('e687e8b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/LoginPage.vue"
export default component.exports